
export const CONFIGURATION_LOADED = 'CONFIGURATION_LOADED';
